import { CUSTOMER_REDIRECT } from 'shared/experiments/consts'
import { isExperimentEnabled } from 'shared/experiments/utils/experiments'
import { type Tenant } from 'types/shopConfig'

import CustomerRedirectionModal from './CustomerRedirectionModal'

const customerRedirectionModal = () => {
  if (isExperimentEnabled(CUSTOMER_REDIRECT)) {
    void new CustomerRedirectionModal().init()
  }
}

export const showRedirectionModal = (tenant: Tenant) => {
  new CustomerRedirectionModal().showForTenant(tenant)
}

export default customerRedirectionModal
